module.exports = __webpack_public_path__ + "img/vegan.b349c51b.png";